const playerSearchTranslation = {
  en: {
    searchTitle: 'Search Players',
    searchPlaceholder: 'Type player name...',
    position: 'Position',
    height: 'Height',
    weight: 'Weight',
    jerseyNumber: 'Jersey Number',
    college: 'College',
    country: 'Country',
    draftYear: 'Draft Year',
    draftRound: 'Draft Round',
    draftNumber: 'Draft Number',
    teamInfoTitle: 'Team Information',
    team: 'Team',
    city: 'City',
    conference: 'Conference',
    division: 'Division',
    noTeam: 'No team',
    noPlayersFound: 'No players found for',
  },
  pl: {
    searchTitle: 'Szukaj Graczy',
    searchPlaceholder: 'Wpisz nazwisko gracza...',
    position: 'Pozycja',
    height: 'Wzrost',
    weight: 'Waga',
    jerseyNumber: 'Numer na koszulce',
    college: 'Uczelnia',
    country: 'Kraj',
    draftYear: 'Rok draftu',
    draftRound: 'Runda draftu',
    draftNumber: 'Numer draftu',
    teamInfoTitle: 'Informacje o zespole',
    team: 'Drużyna',
    city: 'Miasto',
    conference: 'Konferencja',
    division: 'Dywizja',
    noTeam: 'Brak zespołu',
    noPlayersFound: 'Nie znaleziono graczy dla',
  },
};

export default playerSearchTranslation;
